import { getValFrmDict, sdgs, slug } from '../../../k4dAdmin/data';
import { truncateForLink } from '../../data';
import f from './f.module.scss';

import { useApiProviderCtx } from '../../context/api';
export default function MyFooter() {
  const { userbaselink } = useApiProviderCtx();
  return (
    <>
      <div className={f.mrc}>
        <div>
          <h3 className={f.title}>Knowledge for development</h3>
          <div className={f.sdglist}>
            <div>
              <a href="/en/privacy-policy">Privacy Policy</a>
            </div>
            <div>
              <a href="/en/about">About</a>
            </div>
            <div>
              <a href="/en/pricing">Pricing</a>
            </div>
            <div>
              <a href="/en/contact-us">Contact Us</a>
            </div>
            <div>
              <a href="/en/terms-of-use">terms of uses</a>
            </div>
            <div>
              <a href="/en/faq">Faq</a>
            </div>
            <div>
              <a href={`${userbaselink}/auth/signup`}>Join Us</a>
            </div>
          </div>
        </div>

        <div>
          <h3 className={f.title}>Sustainable development goals</h3>
          <div className={f.sdglist}>
            {sdgs?.map((n, i) => {
              return (
                <div key={i}>
                  <a href={`/en/${slug(n?.name)}`}>{n.name}</a>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={f.con}>
        <div className={f.le}>
          © 2024 Knowledge for development &nbsp;
          <a>Sitemap.</a>
        </div>

        <div className={f.ri}>
          <a>Twitter</a>
          <a>Instagram</a>
        </div>
      </div>
    </>
  );
}
